import React from 'react'
import FlatListing from './header/FlatListing'
import LayoutSection from './layout/layout'
import { useOutletContext } from 'react-router-dom';

const ShowPropertyGalleryPage = () => {

  return (
    <div className='max-w-[96%] mx-auto'>
        <FlatListing/>
        <LayoutSection/>
    </div>
  )
}

export default ShowPropertyGalleryPage